module.exports = __webpack_public_path__ + "img/top-image-600x338.fd5a28be.jpg";